import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

/** Netflix-style horizontal carousel. Cards are placed in a flex row that
 * scrolls horizontally; arrows nudge by a viewport-width. Snap is enabled
 * for a calm, magazine-style page-turn feel. Touch-friendly on mobile.
 */
export default function Carousel({ children, accent = "var(--bronze)", testId, itemWidth = 180 }) {
  const ref = useRef(null);

  function scrollBy(dir) {
    const el = ref.current;
    if (!el) return;
    el.scrollBy({ left: dir * (el.clientWidth * 0.85), behavior: "smooth" });
  }

  return (
    <div className="relative group" data-testid={testId}>
      <button
        type="button"
        aria-label="Scroll left"
        onClick={() => scrollBy(-1)}
        className="hidden sm:flex absolute -left-3 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full border bg-[var(--card-bg)]/95 backdrop-blur-sm shadow-md items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
        style={{ borderColor: accent, color: accent }}
      >
        <ChevronLeft size={16} strokeWidth={1.6}/>
      </button>
      <div
        ref={ref}
        className="flex gap-4 overflow-x-auto snap-x snap-mandatory scroll-smooth pb-3 -mx-2 px-2"
        style={{ scrollbarWidth: "thin" }}
      >
        {Array.isArray(children) ? children.map((c, i) => (
          <div key={c?.key ?? i} className="snap-start shrink-0" style={{ width: itemWidth }}>{c}</div>
        )) : children}
      </div>
      <button
        type="button"
        aria-label="Scroll right"
        onClick={() => scrollBy(1)}
        className="hidden sm:flex absolute -right-3 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full border bg-[var(--card-bg)]/95 backdrop-blur-sm shadow-md items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
        style={{ borderColor: accent, color: accent }}
      >
        <ChevronRight size={16} strokeWidth={1.6}/>
      </button>
    </div>
  );
}
